import React, {Component} from 'react';
import { ServiceCollectionParam } from "../comp/ServiceCollection";
import { RouteComponentProps, withRouter } from "react-router-dom";

type State = {
    outputLog: string
}

type Event = { preventDefault: () => void }

class OutputLog extends Component<ServiceCollectionParam & RouteComponentProps, State> {

    state: State = {
        outputLog: ''
    }

    async componentDidMount() {
        let params: any = this.props.match.params;
        let userName = params.userName;
        let tag = params.tag;

        this.state.outputLog = await this.props.services.dao.getOutputLog(userName, tag);

        this.setState(this.state);
    }

    back(e: Event) {
        e.preventDefault();

        this.props.history.goBack();
    }

    render() {
        return (
            <>
            <div className="card">
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                        <a href="" onClick={ e => this.back(e) }>Tagasi</a>
                    </li>
                    <li className="list-group-item">
                        <pre> { this.state.outputLog } </pre>
                    </li>
                </ul>
            </div>
            </>);
    }

}

export default withRouter(OutputLog)